const initState = {
  productsError: null,
  products: [],
  wardrobeHulls: [],
  wardrobeHullsError: null,
  cornerHulls: [],
  cornerHullsError: null,
  cornerHulls66x45: [],
  cornerHulls45x66: [],
  cornerHulls66x66: [],
  fronts: [],
  frontsOutside: [],
  frontsInside: [],
  frontsGroup: {},
  frontsError: null,
  frontsGroupError: null,
  handlesColors: [],
  handlesColorsError: null,
  imagesList: {
    textures: {},
    models_3d: {},
    icons: {},
  },
  imagesListError: null,
};

const productsReducer = (state = initState, action) => {
  switch (action.type) {
    case 'GET_IMAGES_LIST_SUCCESS':
      return {
        ...state,
        imagesList: action.data,
        imagesListError: null,
      };
    case 'GET_PRODUCTS_SUCCESS':
      return {
        ...state,
        products: action.data,
        productsError: null,
      };
    case 'GET_PRODUCTS_ERROR':
      return {
        ...state,
        productsError: action.data,
      };
    case 'GET_WARDROBE_HULLS_SUCCESS':
      return {
        ...state,
        wardrobeHulls: action.data,
        wardrobeHullsError: null,
      };
    case 'GET_WARDROBE_HULLS_ERROR':
      return {
        ...state,
        wardrobeHulls: null,
        wardrobeHullsError: action.data,
      };

    case 'GET_CORNER_HULLS_SUCCESS':
      return {
        ...state,
        cornerHulls: action.data,
        cornerHulls66x45: action.data.filter(item => item.types.hasOwnProperty(9)),
        cornerHulls45x66: action.data.filter(item => item.types.hasOwnProperty(10)),
        cornerHulls66x: action.data.filter(item => item.types.hasOwnProperty(11)),
        cornerHullsError: null,
      };
    case 'GET_CORNER_HULLS_ERROR':
      return {
        ...state,
        cornerHulls: null,
        cornerHullsError: action.data,
        cornerHulls66x45: null,
        cornerHulls45x66: null,
        cornerHulls66x: null,
      };
    case 'GET_FRONTS_SUCCESS':
      return {
        ...state,
        fronts: action.data,
        frontsOutside: action.data.filter(item => item.safo.includes('Z-')),
        frontsInside: action.data.filter(item => item.safo.includes('W-')),
        frontsError: null,
      };
    case 'GET_FRONTS_ERROR':
      return {
        ...state,
        fronts: [],
        frontsOutside: [],
        frontsInside: [],
        frontsError: action.data,
      };
    case 'GET_FRONTS_GROUP_SUCCESS':
      return {
        ...state,
        frontsGroup: action.data,
        frontsGroupError: null,
      };
    case 'GET_FRONTS_GROUP_ERROR':
      return {
        ...state,
        frontsGroup: null,
        frontsGroupError: action.data,
      };
    case 'GET_BODIES_COLORS_SUCCESS':
      return {
        ...state,
        bodyColors: action.data,
        bodyColorsError: null,
      };

    case 'GET_BODIES_COLORS_ERROR':
      return {
        ...state,
        bodyColors: null,
        bodyColorsError: action.data,
      };

    case 'GET_HANDLES_LIST_SUCCESS':
      return {
        ...state,
        handlesColors: action.data,
        handlesColorsError: null,
      };

    case 'GET_HANDLES_LIST_ERROR':
      return {
        ...state,
        handlesColors: null,
        handlesColorsError: action.data,
      };

    default:
      return state;
  }
};

export default productsReducer;
